export function index()
{
    return axios.get(route('api.manage.companies.components'))
        .then(response => response.data);
}

export function store(data)
{
    return axios.post(route('api.manage.companies.components'), data)
        .then(response => response.data);
}

export function update(componentId, data)
{
    return axios.patch(route('api.manage.components.update', { componentId: componentId }), data)
        .then(response => response.data);
}

export function destroy(componentId)
{
    return axios.delete(route('api.manage.components.destroy', { componentId: componentId }));
}

export function updateSort(sort) {
    return axios.patch(route('api.manage.companies.components.sort'), {
        data: sort
    }).then(response => {
        return response.data;
    });
}
